export const LOGIN_API = "users/login";
export const CLIENT_LIST_ROUTE = "/client-list";
export const CLIENT_CREATE = "bbuser";
export const LEAD_GENERATION_API = "bbuser/generate_lead_report";
export const REPORT_GENERATION_API = "bbuser/generate_report";
export const CLIENT_EDIT_VIEW_ROUTE = "/client-edit-view";
export const CHECK_INVOICE_EXIST = "bbuser/checkinvoiceexist/";
export const GET_RC_EXCEL_LIST = "vehicle/getrcexcellist/";
export const GET_RC_ENGINE_EXCEL_LIST = "vehicle/getrcengineexcellist/";
export const FORGOT_PASSWORD = "bbuser/forgotpassword";
export const CLIENT_EDIT_VIEW = "bbuser/bbuserdetail/";
export const EMAIL_IS_EXIST_URL = "bbuser/isemailexist";
export const CONTACT_IS_EXIST_URL = "bbuser/iscontactexist";
export const CLIENT_ADD_NEW_SERVICE = "bbuser/addcilentservice/";
export const RCEXCEL_API = "bbuser/vehicle_registration_detail_excel";
export const CHALLANEXCEL_API = "bbuser/challan_detail_excel";
export const MOBILE_RC_EXCEL_API = "bbuser/mobile_rc_detail_excel";
export const RCENGINEEXCEL_API = "bbuser/vehicle_registration_detail_enginechasis_excel";
export const CLIENT_ADD_EDIT_NEW_EXIST_SERVICE = "bbuser/editcilentservice/";
export const PLAN_STATUS_CHANGE = "bbuser/planstatuschange";
export const CLIENT_STATUS_UPDATE = "bbuser/status/update";
export const CLIENT_INFO_UPDATE = "bbuser/updateClientProfileInfo"
export const CLIENT_LIST = "bbuser/clientList";
export const CLIENT_UPDATE_PREPAID_POSTPAID_BALANCE = "bbuser/updateperpaidpostpaidbalance";
export const LOGIN_ROUTE = "/login";
export const SHOW_MORE = "Show More";
export const SHOW_LESS = "Show Less";
export const PRE = "pre";
export const POS = "post";
export const PREPAID = "Prepaid";
export const POSTPAID = "Postpaid";
export const LOGIN_TYPE_ADMIN = "admin";
export const LOGIN_TYPE_USER = "bbuser";

export const SERVICE0_TEXT = "RC";
export const SERVICE1_TEXT = "DL";
export const SERVICE2_TEXT = "Challan";
export const SERVICE3_TEXT = "ServiceHistory";
export const SERVICE4_TEXT = "RcExtract";
export const SERVICE5_TEXT = "PriceEngineCD";
export const SERVICE6_TEXT = "Fuel";
export const SERVICE7_TEXT = "VehicleTransaction";
export const SERVICE8_TEXT = "StolenVehicles";
export const SERVICE9_TEXT = "RCPrime";
export const SERVICE10_TEXT = "RCExcel";
export const SERVICE12_TEXT = "RCEngineExcel";
export const SERVICE14_TEXT = "ApiHistory";
export const SERVICE15_TEXT = "UsedCarPricing";
export const SERVICE16_TEXT = "RCPrimeReverse";
export const SERVICE17_TEXT = "RCPrimeReverseBasic";
export const SERVICE18_TEXT = "ChallanPdf";
export const SERVICE19_TEXT = "UsedCarPricingV2";
export const SERVICE20_TEXT = "VariantMapping";
export const SERVICE21_TEXT = "RCPrimeReversePdf";
export const SERVICE22_TEXT = "PanFetch";
export const SERVICE23_TEXT = "BasicForgery";
export const SERVICE24_TEXT = "AdvanceForgery";
export const SERVICE25_TEXT = "AadhaarExtraction";
export const SERVICE26_TEXT = "MMV";
export const SERVICE27_TEXT = "PanExtensive";
export const SERVICE28_TEXT = "PanFetchPdf";
export const SERVICE29_TEXT = "PanExtensivePdf";
export const SERVICE30_TEXT = "AadhaarExtractionPdf";
export const SERVICE31_TEXT = "BasicForgeryPdf";
export const SERVICE32_TEXT = "AdvacneForgeryPdf";
export const SERVICE33_TEXT = "comboPrime";
export const SERVICE34_TEXT = "comboChallan";
export const SERVICE35_TEXT = "AadhaarFetch";
export const SERVICE36_TEXT = "AadhaarFetchPdf";
export const SERVICE37_TEXT = "ChallanExcel";
export const SERVICE38_TEXT = "MobileExcel";
export const SERVICE39_TEXT = "comboMobilePrimeExcel";
export const SERVICE40_TEXT = "RawReport";
export const SERVICE41_TEXT = "BuHeadBillingReport";
export const SERVICE42_TEXT = "Dashboard";


//Master Services Module API
export const GET_MASTER_SERVICE = "allservices";
export const GET_MASTER_SERVICE_LIST = "allservices/get-plan-list";
export const POST_MASTER_SERVICE_CREATE = "allservices/plan-create";
export const POST_MASTER_SERVICE_EDIT = "allservices/plan-edit";
export const POST_MASTER_SERVICE_DOC_REMOVE = "allservices/plan-doc-remove";
export const MASTER_SERVICE_CAT = [
        {label:'RC Information', slug:'rcInfo'},
        {label:'Licence Information', slug:'licenceInfo'},
        {label:'Challan Information', slug:'challanInfo'},
        {label:'Service History Information', slug:'serviceHistoryInfo'},
        {label:'Used Car Pricing Information', slug:'usedCarPricingInfo'},
        {label:'Document Verification Information', slug:'docVerificationInfo'},
        {label:'API History Information', slug:'apiHistoryInfo'}
    ];



//export const API_DOC_BASE_URL = "http://api.inbillsolutions.com/bbuser/";
export const API_DOC_BASE_URL = "http://rtoapi.girnarcare.com/bbuser/";
//export const API_DOC_BASE_URL = "http://192.168.32.17:3004/bbuser/";
//export const API_DOC_BASE_URL = "http://localhost:3001/bbuser/";

export const URL_DL = "driving_licence_detail";
export const URL_RC = "vehicle_registration_detail";
export const URL_CHALLAN = "vehicle_challan_detail";
export const URL_SERVICEHISTORY = "vehicle_service_history";
export const URL_RCSCAN = "rc_scan";
export const URL_PRICEENGINECD = "price_engine_cd";
export const URL_FUEL = "fuel_price";
export const URL_VEHICLETRANSACTION = "transaction_status";
export const URL_STOLENVEHICLE = "stolen_vehicles";
export const URL_RCPRIME = "vehicle_registration_detail_prime";
export const URL_RCEXCEL = "vehicle_registration_detail_excel";
export const URL_RCENGINEEXCEL = "vehicle_registration_detail_enginechasis_excel";
export const URL_USEDCARPRICING = "used-car-pricing";
export const URL_RCPRIMEREVERSE = "vehicle_registration_detail_prime_reverse";
export const URL_RCPRIMEREVERSEBASIC = "vehicle_registration_detail_basic_reverse";
export const URL_USEDCARPRICINGv2 = "used_car_pricing_v2";
export const URL_PANFETCH = "pan_details";
export const URL_BASICFORGERY = "basic_forgery";
export const URL_ADVANCEFORGERY = "advance_forgery";
export const URL_AADHAAREXTRACTION = "aadhaar_extraction";
export const URL_MMV = "make_model_variant";
export const URL_PANEXTENSIVE = "pan_extensive_details";
export const URL_RCPRIMECHALLAN = "vehicle_rc_challan_detail";
export const URL_AADHAARFETCH = "aadhaarfetchdetails";


export const FILTER_CHANGE_API = "bbuser/filterClientList";
export const CLIENT_EDIT_PLAN = "bbuser/bbuserdetailedit/";
export const EDIT_CLIENT_CREATED_PLAN = "bbuser/edit_client_created";

export const NEET_HELP_EMAIL= "rtosupport@girnarcare.com";//"helpdesksupport@girnarcare.com";

export const REPORT_DATA_LIMIT = 1000;

// Variant Mapping Consts RTO DB
export const VEHICLE_ALL_BRANDS = 'variantmapping/all-brands';
export const VEHICLE_MODELS_BY_BRAND = 'variantmapping/get-models';
export const VEHICLE_UPDATE_VARIANT_ID = 'variantmapping/update-variant-id';

// Variants Mapping Central DB
export const VEHICLE_ALL_BRANDS_CENTRALDB = 'variantmapping/all-brands-centraldb';
export const VEHICLE_MODELS_BY_BRAND_CENTRALDB = 'variantmapping/get-models-centraldb';
export const VEHICLE_VARIANT_MAPPING_COUNTS = 'variantmapping/mapping-counts';

//RC Prime PDF Download Feature
export const createAndDownloadPdfForRcPrime = "bbuser/createAndDownloadPdfForRcPrime";

//Testing QA user 
export const rc_prime_pdf_rto_user_id="5fd2ff2d00c0de33f0a91ebb";
export const rc_prime_pdf_user_id="5fed7790648ae566a563014c";
export const rc_prime_pdf_Authorization_Token="Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyZW1haWwiOiJhbWlyLnNpZGRpcXVpQGdpcm5hcmNhcmUuY29tIiwiaWF0IjoxNzM0NzgwNjAxLCJleHAiOjE3NjYzMTY2MDF9.igwkbU8GOkjrkGafyS8vP1k01bDD43a2W5ePt8JXX8Y";

// Variants Mapping api's
export const VEHICLE_MODELS_BY_BRAND_CARDEKHO="variantmapping/api-call-from-cardekho-for-brand";
export const VEHICLE_MODELS_BY_MODEL_CARDEKHO="variantmapping/api-call-from-cardekho-for-Model";
export const VEHICLE_MODELS_BY_VARIANT_CARDEKHO="variantmapping/api-call-from-cardekho-for-variant";

export const FindUniqueData="variantmapping/CheckUniqueNess";
// filter data
export const date_filter_based_on_Mapping_status="variantmapping/date_filter_based_on_Mapping_status";
export const VEHICLE_ALL_BRANDS_VM = 'variantmapping/all-brands_for_variant_mapping';
export const VEHICLE_MODELS_BY_BRAND_VM = 'variantmapping/get-models_for_variant_mapping';
export const VEHICLE_UPDATE_VARIANT_ID_VM = 'variantmapping/update-variant-id_for_variant_mapping'; 
export const VEHICLE_DATA_DOWNLOAD = 'variantmapping/create-csv-report';

//Rc prime PDF 
export const unlink_file="bbuser/unlink-file-from-given-path"
export const SERVICE13_TEXT="RCPrimePDF"
//export const API_DOC_URL = "http://admin.inbillsolutions.com/";
export const API_DOC_URL = "http://rtoadmin.girnarcare.com/";
//export const API_DOC_URL = "http://rtoweb.girnarsoft.com/";
//export const API_DOC_URL = "http://localhost:3006/";


// Regenrate Token By admin user.
export const Regenrate_Token='bbuser/regenrate-token-for-given-client-email-id'; 

// Download Report for apihits On Report panel.
export const DOWNLOAD_CSV_REPORT='bbuser/download-csv-report-of-api-hits'; 

//RTO dashboard
export const ClientsAnalysis='Dashboard/clientsAnalysis';
export const Dashboard_API_Hit_Report='Dashboard/api-hit-reports-for-dashboard';
export const Dashboard_Mobile_App="Dashboard/mobile-application-analysis-for-dashboard";
export const Dashboard_Api_clients="Dashboard/apiClientList";
export const Dashboard_Api_hit_counts = "Dashboard/hit-count-dashboard-graph";

//RTO Setting URLs
export const GetSettingURL="commonSetting/get-common-setting";
export const UpdateSettingURL="commonSetting/update-common-setting";
export const api_sources = {
    RCExcel: ['zoop','surepass','gamma','delta','deltav2','deltaCache'],
    RCPrime: ['zoop','surepass','gamma','delta','deltav2','deltaCache','all'],
    RCPrimeReverse: ['gamma'],
    RCFree: ['zoop_lite'],
    Challan: ['gamma','zeta','delta', 'deltaPro', 'all'],
    ChallanExcel: ['gamma','delta', 'deltaPro'],
    FCMChallan: ['gamma','zeta'],
    MobileRCExcel: ['gamma','delta','deltav2','deltaCache'],
};

//All Months Array Using on dashbaord
export const Months = ['January','February','March','April','May','June','July','August','September','October','November','December'];